export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  imageSeq: string;
  imageQuery: string;
  featured: boolean;
}

export const articles: Article[] = [
  {
    slug: 'huangyou-xiangji-xinshou-rumen',
    title: '黄油相机新手入门指南：从下载到精通只需10分钟',
    excerpt: '刚下载黄油相机不知道怎么用？这篇新手入门指南带你快速上手，掌握文字添加、滤镜调色、模板套用等核心功能。',
    content: `<p>黄油相机作为当下最受欢迎的图片美化工具之一，凭借其丰富的字体库和精美的滤镜效果，吸引了大量用户。但对于刚下载黄油相机的新手来说，面对琳琅满目的功能可能会有些不知所措。本文将带你从零开始，快速掌握黄油相机的核心操作。</p>
<h2>第一步：下载与安装</h2>
<p>首先，请确保从官方渠道下载黄油相机App。目前黄油相机支持iOS和Android两大平台，在各自的应用商店搜索"黄油相机"即可找到官方版本。安装完成后，打开App你会看到一个简洁直观的界面。</p>
<h2>第二步：认识主界面</h2>
<p>黄油相机的主界面分为几个核心区域：底部导航栏包含"首页"、"模板"、"拍摄"、"我的"四个主要模块。首页会推荐热门模板和精选作品，模板区可以浏览和搜索各类排版模板，拍摄功能支持直接拍照或从相册导入照片。</p>
<h2>第三步：添加文字</h2>
<p>黄油相机最大的特色就是其强大的文字功能。导入照片后，点击"文字"按钮，你可以选择海量中英文字体，调整字体大小、颜色、间距、行距等参数。黄油相机的字体库包含了手写体、印刷体、艺术字等多种风格，满足不同场景需求。</p>
<h2>第四步：套用滤镜</h2>
<p>点击"滤镜"选项，你会看到黄油相机提供的数十款精心调校的滤镜。从日系清新到复古胶片，从美食专用到人像优化，每款滤镜都能为照片增添独特的氛围感。你还可以手动调整滤镜强度，实现更精准的效果控制。</p>
<h2>第五步：使用模板</h2>
<p>如果你想快速做出好看的照片，模板功能是你的最佳选择。黄油相机内置了海量模板，涵盖日常、美食、旅行、穿搭等多种场景。只需选择喜欢的模板，替换照片和文字即可完成一张精美的图片。</p>
<h2>总结</h2>
<p>黄油相机虽然功能丰富，但上手并不难。掌握以上五个步骤，你就可以轻松制作出令人惊艳的照片了。随着使用的深入，你会发现更多隐藏的高级玩法。</p>`,
    category: 'shiyong-jiaocheng',
    author: '黄油小编',
    date: '2026-07-28',
    readTime: '8分钟',
    tags: ['新手入门', '使用教程', '基础操作'],
    imageSeq: 'article-newbie-01',
    imageQuery: 'A%20warm%20minimalist%20flat%20lay%20of%20a%20smartphone%20displaying%20photo%20editing%20app%20interface%20on%20clean%20desk%20with%20soft%20natural%20light%2C%20creative%20workspace%20vibe%2C%20editorial%20photography%20style%20with%20gentle%20shadows%20and%20creamy%20beige%20background',
    featured: true,
  },
  {
    slug: 'huangyou-xiangji-zuixin-banben-gengxin',
    title: '黄油相机最新版本8.0更新：AI智能排版功能重磅上线',
    excerpt: '黄油相机8.0版本正式发布，新增AI智能排版、一键去水印、批量处理等强大功能，全面提升你的创作效率。',
    content: `<p>黄油相机团队近日正式发布了8.0大版本更新，这是黄油相机今年最重要的一次版本升级。本次更新带来了多项重磅功能，其中最引人注目的就是AI智能排版功能。让我们一起来看看本次更新的详细内容。</p>
<h2>AI智能排版</h2>
<p>这是本次更新的核心亮点。黄油相机8.0引入了AI智能排版引擎，能够自动识别照片内容，根据画面构图、色彩分布和主体位置，智能推荐最佳的文字排版方案。你只需要选择照片，AI就会在几秒内生成多种排版样式供你选择，大大提升了创作效率。</p>
<h2>一键去水印</h2>
<p>新增的智能去水印功能可以自动识别并去除照片中的水印、日期戳等干扰元素。基于深度学习算法，去水印后的区域会自动填充背景内容，几乎看不出痕迹。</p>
<h2>批量处理</h2>
<p>对于需要处理大量照片的用户来说，新增的批量处理功能绝对是一大福音。你可以一次性对多张照片应用相同的滤镜、文字样式或模板，极大地提高了工作效率。</p>
<h2>新增字体与滤镜</h2>
<p>8.0版本还新增了20款精选中英文字体和15款全新滤镜，进一步丰富了创作素材库。新增的字体涵盖了毛笔书法、现代手写、复古印刷等多种风格。</p>
<h2>性能优化</h2>
<p>本次更新还对App性能进行了全面优化，图片加载速度提升30%，滤镜渲染速度提升20%，整体使用体验更加流畅。</p>
<h2>如何更新</h2>
<p>iOS用户可以在App Store中搜索"黄油相机"进行更新，Android用户可以在各大应用商店或通过黄油下载官网获取最新版本。</p>`,
    category: 'gengxin-rizhi',
    author: '黄油小编',
    date: '2026-08-01',
    readTime: '6分钟',
    tags: ['版本更新', 'AI功能', '新功能'],
    imageSeq: 'article-update-02',
    imageQuery: 'A%20modern%20smartphone%20floating%20with%20glowing%20AI%20circuit%20patterns%20around%20it%20on%20a%20warm%20gradient%20background%20of%20soft%20yellow%20and%20cream%20tones%2C%20futuristic%20yet%20approachable%20tech%20aesthetic%2C%20clean%20composition%20with%20subtle%20shadows',
    featured: true,
  },
  {
    slug: 'huangyou-xiangji-lvjing-tiaose-jiqiao',
    title: '黄油相机滤镜调色技巧：5个方法让你的照片质感翻倍',
    excerpt: '学会这些黄油相机滤镜调色技巧，轻松调出电影感、日系风、复古调等多种风格，让你的照片瞬间高级起来。',
    content: `<p>滤镜是黄油相机最受欢迎的功能之一。但很多人只是简单套用默认滤镜，效果往往不尽如人意。今天就来分享5个实用的滤镜调色技巧，帮你充分发挥黄油相机的潜力。</p>
<h2>技巧一：滤镜叠加法</h2>
<p>不要只使用单一滤镜，可以尝试先用一个基础滤镜调整整体色调，保存后再用另一个滤镜进行微调。例如先用"日系清新"提亮画面，再用"暖黄"增加温馨感，这种叠加效果往往比单一滤镜更加丰富。</p>
<h2>技巧二：强度微调</h2>
<p>黄油相机的每款滤镜都支持强度调节。很多人习惯直接使用100%强度，但适当降低到60%-80%反而能让照片看起来更自然。尤其在人像照片中，过强的滤镜会让肤色失真。</p>
<h2>技巧三：分区调色</h2>
<p>利用黄油相机的蒙版功能，可以对照片的不同区域应用不同的滤镜。比如给天空部分使用蓝色增强滤镜，给地面部分使用暖色调滤镜，创造出更具层次感的画面效果。</p>
<h2>技巧四：参数手动调整</h2>
<p>除了套用预设滤镜，手动调整亮度、对比度、饱和度、色温等参数也是重要的调色手段。建议的调整顺序是：先调整曝光和对比度，再调整色温和色调，最后微调饱和度和锐度。</p>
<h2>技巧五：参考优秀作品</h2>
<p>黄油相机的社区中有大量优秀作品，多看多学是快速提升调色水平的好方法。注意观察优秀作品的色调倾向和滤镜搭配，尝试在自己的照片中复现类似效果。</p>`,
    category: 'jiqiao-fenxiang',
    author: '黄油小编',
    date: '2026-07-25',
    readTime: '7分钟',
    tags: ['滤镜', '调色技巧', '照片美化'],
    imageSeq: 'article-filter-03',
    imageQuery: 'A%20beautiful%20flat%20lay%20of%20color%20palette%20swatches%20and%20a%20phone%20showing%20photo%20editing%20app%20on%20a%20warm%20cream%20desk%20surface%2C%20creative%20studio%20atmosphere%20with%20soft%20natural%20side%20lighting%2C%20artistic%20composition',
    featured: true,
  },
  {
    slug: 'huangyou-xiangji-vs-other-apps',
    title: '黄油相机 vs 其他修图App：为什么黄油相机更值得下载',
    excerpt: '市面上的修图App那么多，黄油相机凭什么脱颖而出？我们从字体、滤镜、模板、易用性四个维度进行全面对比。',
    content: `<p>在如今的移动互联网时代，修图App种类繁多，从国际巨头到国内新秀，选择实在太多。那么黄油相机到底有什么独特之处，为什么它值得你优先下载呢？本文将从多个维度为你详细分析。</p>
<h2>字体库方面</h2>
<p>黄油相机的字体库是其最大的核心竞争力。相比其他修图App仅提供几十种基础字体，黄油相机拥有超过500款精选字体，涵盖手写体、书法体、艺术体、印刷体等多种风格，并且每月持续更新。尤其是其中文字体数量和质量，在同类产品中遥遥领先。</p>
<h2>滤镜效果方面</h2>
<p>黄油相机的滤镜由专业设计师精心调校，色彩表现自然高级，不会有廉价感。特别值得一提的是其人像滤镜和美食滤镜，对肤色和食物色泽的处理非常出色。而很多其他App的滤镜偏重欧美审美，在亚洲人肤色上表现不佳。</p>
<h2>模板丰富度方面</h2>
<p>黄油相机内置了数以万计的排版模板，覆盖日常、美食、旅行、穿搭、节日等几乎所有场景。模板由社区创作者持续贡献，风格多样且紧跟潮流。相比之下，多数修图App的模板数量和更新频率都远不及黄油相机。</p>
<h2>操作易用性方面</h2>
<p>黄油相机的界面设计简洁直观，新用户很快就能上手。文字编辑、滤镜调整、模板套用等核心操作的学习成本很低。而一些专业修图App虽然功能强大，但操作复杂，需要较长时间学习。</p>
<h2>总结</h2>
<p>综合来看，黄油相机在字体、滤镜、模板和易用性方面都有明显优势，尤其适合注重文字排版和快速出片的中文用户。如果你还在犹豫下载哪个修图App，黄油相机绝对值得一试。</p>`,
    category: 'jiqiao-fenxiang',
    author: '黄油小编',
    date: '2026-07-20',
    readTime: '6分钟',
    tags: ['对比评测', 'App推荐', '修图工具'],
    imageSeq: 'article-compare-04',
    imageQuery: 'A%20side%20by%20side%20comparison%20of%20two%20smartphones%20displaying%20different%20photo%20editing%20app%20results%20on%20a%20clean%20minimalist%20desk%2C%20warm%20natural%20lighting%2C%20editorial%20product%20comparison%20style%20with%20soft%20shadows',
    featured: false,
  },
  {
    slug: 'huangyou-xiangji-wenzi-paiban-jichu',
    title: '黄油相机文字排版基础：让每张照片的文字都恰到好处',
    excerpt: '文字排版是黄油相机的灵魂功能。本文从字体选择、位置布局、颜色搭配三个角度，教你做出高级感的文字排版。',
    content: `<p>黄油相机之所以叫"黄油相机"，很大程度上是因为其出色的文字功能。文字排版看似简单，但要做好并不容易。本文将从基础开始，系统地讲解黄油相机文字排版的要点。</p>
<h2>字体选择原则</h2>
<p>选择合适的字体是文字排版的第一步。黄油相机提供了丰富的字体选择，但并不是越多越好。一般来说，一张照片上的文字不要超过3种字体，否则会显得杂乱。建议主标题使用较粗的字体突出显示，副标题和正文使用较细的字体形成对比。</p>
<h2>位置布局技巧</h2>
<p>文字的位置要根据照片的构图来决定。常用的布局方式包括：居中布局（适合对称构图的照片）、角落布局（适合主体偏中的照片）、跨图布局（适合需要大面积文字的设计）。黄油相机的网格辅助线功能可以帮助你精确定位文字位置。</p>
<h2>颜色搭配策略</h2>
<p>文字颜色需要与照片背景形成足够的对比度，同时保持整体的和谐感。一个实用的技巧是使用黄油相机的取色器工具，从照片中提取主色调，然后选择其互补色或邻近色作为文字颜色。白色和黑色是最安全的文字颜色选择。</p>
<h2>间距与对齐</h2>
<p>字间距、行间距的设置直接影响到文字的阅读体验。黄油相机支持精细的字间距和行间距调整。一般来说，标题的字间距可以稍大一些（120%-150%），正文的字间距保持默认即可，行间距建议设置在1.5-2倍之间。</p>`,
    category: 'shiyong-jiaocheng',
    author: '黄油小编',
    date: '2026-07-18',
    readTime: '9分钟',
    tags: ['文字排版', '设计技巧', '字体选择'],
    imageSeq: 'article-typography-05',
    imageQuery: 'A%20creative%20flat%20lay%20of%20typography%20samples%20and%20a%20phone%20displaying%20text%20layout%20design%20on%20a%20warm%20beige%20background%2C%20editorial%20design%20vibe%20with%20soft%20natural%20light%2C%20clean%20and%20artistic%20composition',
    featured: false,
  },
  {
    slug: 'huangyou-xiangji-android-xiazai',
    title: '黄油相机安卓版下载安装教程：官方安全渠道详解',
    excerpt: '安卓用户如何安全下载黄油相机？本文整理了官方推荐的所有安卓下载渠道，并附详细安装步骤。',
    content: `<p>对于安卓用户来说，由于安卓应用市场的碎片化，找到黄油相机的官方正版并不总是那么容易。本文将为大家详细介绍安卓版黄油相机的官方安全下载渠道和安装步骤。</p>
<h2>官方下载渠道</h2>
<p>黄油相机安卓版目前可以通过以下官方渠道下载：华为应用市场、小米应用商店、OPPO软件商店、vivo应用商店、应用宝、以及黄油下载官网。建议优先通过手机自带的应用商店下载，以确保安全性和兼容性。</p>
<h2>安装步骤</h2>
<p>1. 打开手机自带的应用商店；2. 在搜索框中输入"黄油相机"；3. 认准开发者名称为"北京缪客科技有限公司"的官方版本；4. 点击"安装"按钮；5. 等待下载和安装完成；6. 打开App，按照引导完成初始设置。</p>
<h2>注意事项</h2>
<p>请勿从不明来源的第三方网站下载黄油相机APK文件，这些文件可能包含恶意代码或广告插件。如果应用商店暂时无法下载，可以访问黄油下载官网获取官方APK安装包。</p>
<h2>常见安装问题</h2>
<p>如果安装过程中提示"未知来源应用"，请在手机设置中开启"允许安装未知来源应用"的权限（安装完成后建议关闭）。如果安装失败，请检查手机存储空间是否充足，以及系统版本是否满足最低要求（Android 6.0及以上）。</p>`,
    category: 'shiyong-jiaocheng',
    author: '黄油小编',
    date: '2026-07-15',
    readTime: '5分钟',
    tags: ['安卓下载', '安装教程', '安全下载'],
    imageSeq: 'article-android-06',
    imageQuery: 'An%20Android%20smartphone%20displaying%20app%20download%20page%20on%20screen%20placed%20on%20a%20warm%20wooden%20desk%20with%20soft%20natural%20light%2C%20clean%20minimalist%20tech%20lifestyle%20photography%2C%20creamy%20background%20tones',
    featured: false,
  },
  {
    slug: 'huangyou-xiangji-muban-zhizuo',
    title: '从零开始制作黄油相机模板：手把手教你做出爆款排版',
    excerpt: '想在黄油相机上制作自己的专属模板？本文手把手教你模板制作全流程，从设计思路到发布分享一步不落。',
    content: `<p>黄油相机的模板功能不仅可以使用现成的模板，还支持用户自行创作和发布模板。如果你有独特的设计想法，制作自己的模板并与社区分享是一件非常有成就感的事情。</p>
<h2>确定模板定位</h2>
<p>在开始制作之前，先确定模板的定位：是日常记录、美食分享、旅行打卡还是节日祝福？不同的场景需要不同的设计风格。建议从自己最熟悉的场景入手。</p>
<h2>设计文字布局</h2>
<p>打开黄油相机，选择一张示例照片，开始设计文字布局。注意文字的大小、位置、间距和颜色搭配。一个好的模板应该能适配不同类型的照片，所以文字位置不宜过于依赖特定照片的构图。</p>
<h2>添加装饰元素</h2>
<p>黄油相机提供了丰富的贴纸和装饰元素，可以适当添加来丰富模板的视觉效果。但注意不要过度使用，保持简洁大方的设计风格。装饰元素应该起到锦上添花的作用，而不是喧宾夺主。</p>
<h2>测试与优化</h2>
<p>完成初步设计后，用不同类型的照片（横版、竖版、亮色调、暗色调）测试模板的适配性。根据测试结果进行调整，确保模板具有良好的通用性。</p>
<h2>发布与分享</h2>
<p>在黄油相机中，你可以将制作好的模板发布到社区，供其他用户使用。优质的模板会获得大量使用和点赞，让你的创作被更多人看到。</p>`,
    category: 'muban-tuijian',
    author: '黄油小编',
    date: '2026-07-12',
    readTime: '7分钟',
    tags: ['模板制作', '创意设计', '排版教程'],
    imageSeq: 'article-template-07',
    imageQuery: 'A%20creative%20workspace%20with%20a%20phone%20showing%20design%20template%20layout%2C%20surrounded%20by%20design%20sketches%20and%20color%20swatches%20on%20a%20warm%20cream%20desk%2C%20artistic%20studio%20atmosphere%20with%20soft%20morning%20light%2C%20clean%20composition',
    featured: false,
  },
  {
    slug: 'huangyou-xiangji-changjian-wenti-jieda',
    title: '黄油相机常见问题汇总：闪退、无法保存、字体缺失一次解决',
    excerpt: '使用黄油相机时遇到闪退、保存失败、字体显示异常等问题？本文整理了最常见的10个问题及其解决方案。',
    content: `<p>在使用黄油相机的过程中，难免会遇到一些技术问题。本文整理了用户反馈最多的10个常见问题及对应的解决方案，希望能帮你快速排除故障。</p>
<h2>问题一：App闪退</h2>
<p>如果黄油相机频繁闪退，首先尝试重启手机。如果问题依旧，检查手机系统是否为最新版本，并确保黄油相机已更新到最新版。在手机设置中清除黄油相机的缓存数据也可能解决问题。</p>
<h2>问题二：照片无法保存</h2>
<p>照片保存失败通常是因为手机存储空间不足或黄油相机没有相册访问权限。请检查手机剩余存储空间，并在系统设置中确保黄油相机拥有"存储"和"相册"权限。</p>
<h2>问题三：字体显示异常</h2>
<p>部分字体在特定手机上显示为方块或乱码，这通常是因为手机系统不支持该字体格式。可以尝试切换其他字体，或者更新手机系统至最新版本。</p>
<h2>问题四：滤镜加载缓慢</h2>
<p>滤镜加载慢可能是因为网络问题或手机性能不足。建议在WiFi环境下使用，关闭后台运行的其他App释放内存。</p>
<h2>问题五：导出画质降低</h2>
<p>在导出设置中选择"原图画质"或"高清"选项可以避免画质损失。注意免费版可能有画质限制，升级会员可解锁无损导出。</p>`,
    category: 'changjian-wenti',
    author: '黄油小编',
    date: '2026-07-10',
    readTime: '8分钟',
    tags: ['常见问题', '故障排除', '使用帮助'],
    imageSeq: 'article-faq-08',
    imageQuery: 'A%20minimalist%20flat%20lay%20of%20a%20phone%20displaying%20help%20and%20support%20screen%20with%20a%20small%20plant%20and%20coffee%20cup%20on%20a%20warm%20beige%20desk%2C%20soft%20natural%20light%20from%20window%2C%20calm%20and%20helpful%20atmosphere',
    featured: false,
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.featured);
};

export const getRelatedArticles = (currentSlug: string, category: string, count: number = 3): Article[] => {
  return articles
    .filter((a) => a.category === category && a.slug !== currentSlug)
    .slice(0, count);
};